import React from "react";
import Logo from "./Logo";
import { useDemoStore } from "../../store/demoStore";

const Header = () => {
  const brand = useDemoStore((state) => state.brand);

  return (
    <div className="relative px-8 pt-7 pb-5 flex flex-row items-center border-b border-border dark:border-gray-700">
      <Logo />
      <div className="ml-3 self-stretch justify-center text-lg text-text-primary dark:text-text-primary-dark leading-7 tracking-tight">
        {brand.name}
      </div>
    </div>
  );
};

export default Header;
